<div class="w-full border border-primary">
    <span>
        {{header}}
    </span>
    <div class="col-span-9">

    </div>
    <div class="col-span-3 border-4 border-red-500">
        <ng-content></ng-content>
    </div>

    <span>
        {{ header }}
    </span>
    <p>END</p>
</div>
